import axios from 'axios'
import { interceptor } from '@/application/utils/interceptor.js'

const domain = process.env.VUE_APP_API_PATH
const getVcardDataApi = (senderNameUuid) => `${domain}api/v1/dashboard/vcard/get-data/${senderNameUuid}/`
const sendVcardDataApi = (senderNameUuid) => `${domain}api/v1/dashboard/vcard/save-data/${senderNameUuid}/`

export const getVcardDataRequest = (senderNameUuid) => interceptor(axios).get(getVcardDataApi(senderNameUuid))
export const saveVcardDataRequest = (senderNameUuid, data) => interceptor(axios).post(sendVcardDataApi(senderNameUuid), { data })
